module.exports = __webpack_public_path__ + "img/file.f72a7789.png";